<!-- Needed by the Angular router for working with the two child states -->
<ui-view></ui-view>
